// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 10.5C3 5.52944 7.02944 1.5 12 1.5C16.9706 1.5 21 5.52944 21 10.5C21 15.1326 17.5 18.9476 13 19.4451V20.9507C14.7579 20.7763 16.3804 20.1472 17.7504 19.1824L18.568 18.6066L19.7195 20.2418L18.9019 20.8176C16.9495 22.1925 14.5676 23 12 23C9.43242 23 7.05045 22.1925 5.09808 20.8176L4.28046 20.2418L5.43199 18.6066L6.24961 19.1824C7.61964 20.1472 9.24209 20.7763 11 20.9507V19.4451C6.50005 18.9476 3 15.1326 3 10.5ZM7.5 10.5C7.5 12.9853 9.51472 15 12 15C14.4853 15 16.5 12.9853 16.5 10.5C16.5 8.01472 14.4853 6 12 6C9.51472 6 7.5 8.01472 7.5 10.5ZM9.5 10.5C9.5 11.8807 10.6193 13 12 13C13.3807 13 14.5 11.8807 14.5 10.5C14.5 9.11929 13.3807 8 12 8C10.6193 8 9.5 9.11929 9.5 10.5Z"}}]};

const Camera2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'camera-2-filled',
    ref,
    icon: element,
  },
));

Camera2FilledIcon.displayName = 'Camera2FilledIcon';

export default Camera2FilledIcon;
